/**
 * Get the window dimensions
 */
export const getWindowDimensions = () => {
  const { innerWidth, innerHeight } = window;

  return { innerWidth, innerHeight };
};